<template>
    <button type="button"
        v-on:click="openModal"
        class="btn btn-rounded btn-icon btn-sm btn-success">
        <i class="material-icons">add</i>{{ label }}
    </button>
</template>
<script>
import _ from 'lodash';
import Vuex from 'vuex';

export default {
    data() {
        return {

        }
    },

    props: ['content', 'config', 'addNotification'],

    components: {

    },

    computed: {
        label() {
            return _.get(this.config, 'label');
        },

        endpoint() {
            return _.get(this.content, 'links.new');
        },

        formConfig() {
            return _.get(this.config, 'formConfig', {});
        },
    },

    watch: {

    },

    methods: {
        ...Vuex.mapActions('sub', [
            'setStatus',
            'getInitialData',
        ]),

        openModal() {
            this.setStatus(true);
            this.getInitialData(this.endpoint);
        },

        closeModal() {
            this.setStatus(false);
        },
    }
}
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/table-elements/FormModalAddButtonComponent.vue